import React from 'react';
import { Form, Icon, Message } from 'semantic-ui-react'
import _find from 'lodash/find';

import EstaSeguro from '../../../components/funcionales/estaseguro'

class VerInfoTarea2 extends React.Component {
  state={
    argsDocum: {
      descrInfoTarea: this.props.idLista.descrInfoTarea,
      codInfoTarea: this.props.idLista.codInfoTarea, 
      codInfoTareaAnt: this.props.idLista.codInfoTarea, 
      nombreArchivo: this.props.idLista.nombreArchivo?this.props.idLista.nombreArchivo:'',
      nombreArchivoAnt: this.props.idLista.nombreArchivo?this.props.idLista.nombreArchivo:'',
      _id: this.props.idLista._id, file: ''
    },
    confirmaAct: false,
    open: false
  }

  handleChange = (ev) => {
    if (this.props.permiteUpdate){
      const argsDocum = this.state.argsDocum
      this.setState({confirmaAct: false})
      if(ev.target.name==='codInfoTarea' || ev.target.name==='descrInfoTarea'){
        argsDocum[ev.target.name] = ev.target.value
        this.setState({argsDocum});
      }
      if(ev.target.files[0]){
        let file = ev.target.files[0]
        let nombreArchivoInfo = ev.target.files[0].name
        argsDocum['nombreArchivoInfo'] = nombreArchivoInfo
        argsDocum['file'] = file
        this.setState({argsDocum});
      }
    }
  }

  handleQuestionUpdDel = async (ev) => {
    var btnPress = await ev.target.attributes[0].value
    if(btnPress==="btnUpdDel" && !this.state.confirmaAct){this.setState({open: true})}else{this.setState({open: false})};
    if(btnPress==="No"){
      this.setState({open: false})
    };
    if(btnPress==="Si"){
      this.setState({confirmaAct: true})
      this.setState({open: false})
      const myBtn = await document.getElementById("btnUpdDel");
      myBtn.click()
    }
  }

  render(){
    const {argsDocum, confirmaAct, open} = this.state;
    let estilos = Object.assign({}, this.props.styles.input, {cursor: 'pointer'})
    let codInfoTareaAnt = this.props.idLista.codInfoTarea
    let nombreArchivoInfoAnt = this.props.idLista.nombreArchivoInfo
    return(
      <div>
        <button className="ui right labeled icon button" style={this.props.styles.titBuscar}>
          <i className="large hand point down yellow icon"></i>
          InforTarea de ejecución
        </button>
        <div style={this.props.styles.box}>
          <Form name="form1" id="form1" onSubmit={confirmaAct?(ev)=>this.props.handleSubmit(ev, argsDocum, codInfoTareaAnt, nombreArchivoInfoAnt):()=>{}}>
            <div className="ui one column stackable grid">
              <div className="row container">
                <div className="column" width="100%">
                  <Form.Field>
                    <label style={this.props.styles.label}>Código de advertencia</label>
                    <Form.Input autoComplete="off" name="codInfoTarea" id="codInfoTarea" value={this.props.permiteUpdate?argsDocum.codInfoTarea:this.props.idLista.codInfoTarea} onChange={this.handleChange} placeholder='Código advertencia' icon={!this.props.errors.length?null: _find(this.props.errors, {path:'codInfoTarea'})?<Icon name="remove circle" color="red" size="large" />:<Icon name="check circle outline" color="green" size="large" />} />
                  </Form.Field>
                  <Form.Field>
                    <label style={this.props.styles.label}>Descripción de advertencia</label>
                    <Form.Input autoComplete="off" name="descrInfoTarea" id="descrInfoTarea" value={this.props.permiteUpdate?argsDocum.descrInfoTarea:this.props.idLista.descrInfoTarea} onChange={this.handleChange} placeholder='Descripción de advertencia' icon={!this.props.errors.length?null: _find(this.props.errors, {path:'descrInfoTarea'})?<Icon name="remove circle" color="red" size="large" />:<Icon name="check circle outline" color="green" size="large" />} />
                  </Form.Field>
                  <Form.Field>
                  <label style={this.props.styles.label}>
                    Seleccionar archivo de advertencia...&nbsp;&nbsp;
                  </label>
                  <input id="file" name="file" type="file" style={estilos} onChange={this.handleChange}></input>
                </Form.Field>
                  <EstaSeguro permiteUpdate={this.props.permiteUpdate} permiteDelete={this.props.permiteDelete} open={open} styles={this.props.styles} handleQuestionUpdDel={this.handleQuestionUpdDel}/>
                </div>

                {
                  this.props.errors.length?<Message negative header="Los siguientes errores:"
                  list={this.props.errors.map(error=>`${error.path}: ${error.message}`)} />:null
                }

              </div>
            </div>
          </Form>
        </div>
      </div>
    )
  }
}

export default VerInfoTarea2
